import React, {useEffect, useState} from "react";
import {
    customerLogin, login, sendWhatsappVerificationCode
} from "../../../services/auth";
import {
    Alert, CircularProgress, LinearProgress, Snackbar
} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../../context/AuthContext";

export default function LoginPage() {
    const navigate = useNavigate();
    const {user, setUserToken, setUserData, setInstitutionData} = useAuth();

    const [verificationCodeSent, setVerificationCodeSent] = useState(false);
    const [loginData, setLoginData] = useState({
        phone: "", code: "", email: "", password: ""
    });
    const [isLoading, setIsLoading] = useState(false);
    const [isSendingVerificationCode, setIsSendingVerificationCode] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarContent, setSnackbarContent] = useState({
        message: "", type: ""
    });
    const [loginRole, setLoginRole] = useState("employee");

    const handleChange = (field, value) => setLoginData((prev) => ({...prev, [field]: value}));

    const validatePhone = (phone) => /^\d{8,15}$/.test(phone);
    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleSendVerificationCode = async () => {
        if (!validatePhone(loginData.phone)) {
            setSnackbarContent({
                message: "يرجى إدخال رقم هاتف صحيح", type: "error"
            });
            setSnackbarOpen(true);
            return;
        }

        try {
            setIsSendingVerificationCode(true);
            await sendWhatsappVerificationCode(loginData.phone);
            setSnackbarContent({
                message: "تم ارسال رمز التحقق الى تطبيق واتساب", type: "success"
            });
            setVerificationCodeSent(true);
        } catch (err) {
            setSnackbarContent({
                message: "فشل إرسال رمز التحقق. يرجى التأكد من الرقم.", type: "error"
            });
        } finally {
            setSnackbarOpen(true);
            setIsSendingVerificationCode(false);
        }
    };

    const handleLogin = async () => {
        try {
            setIsLoading(true);
            let res, userData;

            if (loginRole === "customer") {
                if (!validatePhone(loginData.phone) || !loginData.code) {
                    setSnackbarContent({
                        message: "يرجى إدخال رقم الهاتف ورمز التحقق بشكل صحيح", type: "error"
                    });
                    setSnackbarOpen(true);
                    return;
                }

                res = await customerLogin(loginData.phone, loginData.code);
                userData = res.data.customer;
                userData.phone = res.data.phone;

                setUserData(userData);
                setUserToken(res.data.accessToken);
                navigate("/institutions");
            } else {
                if (!validateEmail(loginData.email) || !loginData.password) {
                    setSnackbarContent({
                        message: "يرجى إدخال البريد الإلكتروني وكلمة المرور بشكل صحيح", type: "error"
                    });
                    setSnackbarOpen(true);
                    return;
                }

                res = await login(loginData.email, loginData.password);
                userData = res.data.user;
                userData.email = res.data.email;
                userData.role = res.data.user.roles[0];

                setUserData(userData);
                setInstitutionData(res.data.institution)
                setUserToken(res.data.accessToken);
                navigate(`/${userData.role}`);
            }
        } catch (err) {
            setSnackbarContent({
                message: "فشل تسجيل الدخول. يرجى التحقق من البيانات.", type: "error"
            });
            setSnackbarOpen(true);
        } finally {
            setIsLoading(false);
            if (loginRole === "customer") {
                setLoginData({phone: "", code: "", email: "", password: ""});
                setVerificationCodeSent(false);
            }
        }
    };

    useEffect(() => {
        if (user) {
            navigate(`/${user.role}`);
        }
    }, [user]);

    return (<>
        <div className="page">
            <div
                className="content-view"
                style={{
                    flex: 1, display: "flex", alignItems: "center", justifyContent: "center"
                }}
            >
                {isLoading ? (<CircularProgress/>) : (<>
                    <div className="card">
                        <h2>تسجيل الدخول</h2>

                        {/* Role Toggle */}
{/*                        <div className="role-toggle">
                            <button
                                disabled={isLoading || verificationCodeSent || isSendingVerificationCode}
                                className={`btn ${loginRole === 'customer' ? 'filled' : 'outline'} ${isLoading ? 'disabled' : ''}`}
                                onClick={() => {
                                    setLoginRole('customer');
                                    setLoginData({phone: "", code: "", email: "", password: ""});
                                    setVerificationCodeSent(false);
                                }}
                            >
                                عميل
                            </button>
                            <button
                                disabled={isLoading || verificationCodeSent || isSendingVerificationCode}
                                className={`btn ${loginRole === 'employee' ? 'filled' : 'outline'} ${isLoading || verificationCodeSent || isSendingVerificationCode ? 'disabled' : ''}`}
                                onClick={() => {
                                    setLoginRole('employee');
                                    setLoginData({phone: "", code: "", email: "", password: ""});
                                    setVerificationCodeSent(false);
                                }}
                            >
                                موظف
                            </button>
                        </div>*/}

                        {/* Form Fields */}
                        <div className="form-group">
                            {loginRole === "customer" ? (<>
                                <div className="form-group">
                                    <label>رقم الهاتف</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        placeholder="أدخل رقم الهاتف"
                                        value={loginData.phone}
                                        onChange={(e) => {
                                            const digitsOnly = e.target.value.replace(/\D/g, "");
                                            handleChange("phone", digitsOnly);
                                        }}
                                    />
                                </div>
                            </>) : (<>
                                <div className="form-group">
                                    <label>البريد الالكتروني</label>
                                    <input
                                        type="text"
                                        placeholder="أدخل البريد الالكتروني"
                                        value={loginData.email}
                                        onChange={(e) => handleChange("email", e.target.value)}
                                    /></div>
                                <div className="form-group">
                                    <label>كلمة المرور</label>
                                    <input
                                        type="password"
                                        placeholder="*****"
                                        value={loginData.password}
                                        onChange={(e) => handleChange("password", e.target.value)}
                                    />
                                </div>
                            </>)}
                        </div>

                        {/* Verification Code Input */}
                        {loginRole === "customer" && verificationCodeSent && (<div className="form-group">
                            <label>رمز التحقق</label>
                            <input
                                type="text"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                placeholder="أدخل رمز الدخول"
                                value={loginData.code}
                                onChange={(e) => {
                                    const digitsOnly = e.target.value.replace(/\D/g, "");
                                    handleChange("code", digitsOnly);
                                }}
                            />
                        </div>)}

                        {/* Progress Bar */}

                        {isSendingVerificationCode ? <LinearProgress color="primary"/> : ''}

                        {/* Action Button */}
                        <button
                            className={`btn filled ${isLoading || isSendingVerificationCode ? 'disabled' : ''}`}
                            style={{
                                width: "100%", padding: "10px 0", fontSize: "15px"
                            }}
                            onClick={loginRole === "customer" ? verificationCodeSent ? handleLogin : handleSendVerificationCode : handleLogin}
                            disabled={isLoading || isSendingVerificationCode}
                        >
                            {isSendingVerificationCode ? "جاري الإرسال..." : loginRole === "customer" ? verificationCodeSent ? "تسجيل الدخول" : "ارسال رمز الدخول" : "تسجيل الدخول"}
                        </button>
                    </div>

                    {/* Snackbar */}
                    <Snackbar
                        open={snackbarOpen}
                        autoHideDuration={6000}
                        onClose={() => setSnackbarOpen(false)}
                    >
                        <Alert
                            onClose={() => setSnackbarOpen(false)}
                            severity={snackbarContent.type}
                            variant="filled"
                            sx={{width: "100%"}}
                        >
                            {snackbarContent.message}
                        </Alert>
                    </Snackbar>
                </>)}
            </div>
        </div>

        <style jsx>{`
            @media (max-width: 960px) {
                .card {
                    padding: 1.5rem;
                }
            }

            .role-toggle {
                display: flex;
                margin-bottom: 1rem;
                gap: 10px;
            }

            .role-toggle button {
                flex: 1;
                padding: 10px;
                border: 1px solid #ccc;
                background-color: #fff;
                cursor: pointer;
                font-size: 16px;
            }
        `}</style>
    </>);
}